const CATEGORY_ORDER = {
  earrings: ["necklaces", "bracelets"],
  necklaces: ["earrings", "bracelets"],
  bracelets: ["earrings", "necklaces"],
};

const money = (n) =>
  new Intl.NumberFormat("el-GR", { style: "currency", currency: "EUR" }).format(n);

function cartAddUrl() {
  const root = window.Shopify?.routes?.root || "/";
  return `${root}cart/add.js`;
}

async function loadConfig() {
  const node = document.querySelector("[data-aph-combo-config-url]");
  if (!node) return null;
  const url = JSON.parse(node.textContent || '""');
  const res = await fetch(url, { credentials: "same-origin" });
  if (!res.ok) throw new Error("combo config load failed");
  return res.json();
}

function buildField(categoryKey, label, options) {
  const wrap = document.createElement("div");
  wrap.className = "aph-team-combo__field";
  wrap.dataset.aphCategory = categoryKey;

  const lab = document.createElement("label");
  lab.className = "aph-team-combo__label";
  lab.textContent = `Προσθήκη ${label}`;
  lab.setAttribute("for", `aph-team-${categoryKey}`);

  const select = document.createElement("select");
  select.className = "aph-team-combo__select";
  select.id = `aph-team-${categoryKey}`;
  select.dataset.aphCategory = categoryKey;

  const none = document.createElement("option");
  none.value = "";
  none.textContent = "Όχι, ευχαριστώ";
  select.appendChild(none);

  for (const item of options) {
    const opt = document.createElement("option");
    opt.value = String(item.variantId);
    opt.textContent = item.label;
    opt.dataset.sku = item.sku;
    select.appendChild(opt);
  }

  wrap.append(lab, select);
  return wrap;
}

function selectedItems(root, config) {
  const baseVariantId = Number(root.dataset.baseVariantId);
  const items = [{ id: baseVariantId, quantity: 1 }];
  root.querySelectorAll(".aph-team-combo__select").forEach((select) => {
    const value = select.value;
    if (value) items.push({ id: Number(value), quantity: 1 });
  });
  return items;
}

function updateTotal(root, config) {
  const count = selectedItems(root, config).length;
  const total = Number(config.price) * count;
  const totalEl = root.querySelector("[data-aph-team-total-value]");
  if (totalEl) totalEl.textContent = money(total);
}

async function addBundle(root, config) {
  const items = selectedItems(root, config);
  const res = await fetch(cartAddUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items }),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.description || data.message || "Add to cart failed");
  }
  window.location.href = `${window.Shopify?.routes?.root || "/"}cart`;
}

function bindForm(root, config) {
  const productForm = root.closest(".product-details")?.querySelector("product-form-component form")
    || document.querySelector("product-form-component form");
  if (!productForm) return;

  productForm.addEventListener(
    "submit",
    async (event) => {
      const selects = root.querySelectorAll(".aph-team-combo__select");
      const hasAddon = [...selects].some((s) => s.value);
      if (!hasAddon) return;

      event.preventDefault();
      event.stopPropagation();

      const button = productForm.querySelector('[name="add"], button[type="submit"]');
      if (button) button.disabled = true;

      try {
        await addBundle(root, config);
      } catch (error) {
        console.error("[aph-team-combo]", error);
        if (button) button.disabled = false;
        window.alert("Δεν ήταν δυνατή η προσθήκη του συνδυασμού. Δοκιμάστε ξανά.");
      }
    },
    true
  );
}

async function initTeamCombo(root) {
  const config = await loadConfig();
  const team = root.dataset.team;
  const category = root.dataset.category;
  const fieldsHost = root.querySelector("[data-aph-team-fields]");
  const totalHost = root.querySelector("[data-aph-team-total]");
  if (!config?.teams?.[team] || !fieldsHost) return;

  const categories = CATEGORY_ORDER[category] || [];
  for (const catKey of categories) {
    const options = config.teams[team][catKey] || [];
    const filtered = options.filter((item) => item.sku !== root.dataset.baseSku);
    if (!filtered.length) continue;
    const label = config.categoryLabels?.[catKey] || catKey;
    fieldsHost.appendChild(buildField(catKey, label, filtered));
  }

  if (!fieldsHost.children.length) {
    root.hidden = true;
    return;
  }

  fieldsHost.hidden = false;
  totalHost.hidden = false;
  updateTotal(root, config);

  fieldsHost.addEventListener("change", () => updateTotal(root, config));
  bindForm(root, config);
}

function boot() {
  document.querySelectorAll("[data-aph-team-combo]").forEach((root) => {
    if (root.dataset.aphReady === "true") return;
    root.dataset.aphReady = "true";
    initTeamCombo(root).catch((err) => console.error("[aph-team-combo]", err));
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
document.addEventListener("shopify:section:load", boot);
